import { sendRequest } from './backendCommon';
import { REQUESTS } from '../../constants/backend';
import { saveRealtimeCallChecker } from '../../utils/background/asr';
import type { BackendAppConfig } from '../types';

export const types = {
    GET_APP_CONFIG: '@bg/GET_APP_CONFIG',
    GET_APP_CONFIG_SUCCESS: '@bg/GET_APP_CONFIG_SUCCESS',
    GET_APP_CONFIG_FAIL: '@bg/GET_APP_CONFIG_FAIL',

    UPDATE_APP_CONFIG: '@bg/UPDATE_APP_CONFIG',
    UPDATE_APP_CONFIG_SUCCESS: '@bg/UPDATE_APP_CONFIG_SUCCESS',
    UPDATE_APP_CONFIG_FAIL: '@bg/UPDATE_APP_CONFIG_FAIL',

    SET_RECORD_CALL: '@bg/SET_RECORD_CALL'
};

type ThunkDispatch = (action: unknown) => unknown;

function isRecord(value: unknown): value is Record<string, unknown> {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}

function toConfigPayload(config: unknown): { config: BackendAppConfig } {
    return { config: isRecord(config) ? (config as unknown as BackendAppConfig) : ({} as BackendAppConfig) };
}

export const requestClientConfig =
    ({ pending, success, fail }: { pending: string; success: string; fail: string }) =>
    () =>
    (dispatch: ThunkDispatch) => {
        const onSuccess = (config: unknown) => {
            dispatch({
                type: success,
                payload: toConfigPayload(config)
            });
        };

        const onError = (error: unknown) => {
            dispatch({ type: fail, error });
        };
        dispatch({ type: pending });
        dispatch(sendRequest(REQUESTS.GET_APP_CONFIG, { onSuccess, onError }));
    };

export const updateRecordCall = (realtimeOnlyCallsPercent: number) => (dispatch: ThunkDispatch) => {
    const recordCall = saveRealtimeCallChecker(realtimeOnlyCallsPercent);

    dispatch({
        type: types.SET_RECORD_CALL,
        payload: {
            recordCall
        }
    });
};

export const getAppConfig = requestClientConfig({
    pending: types.GET_APP_CONFIG,
    success: types.GET_APP_CONFIG_SUCCESS,
    fail: types.GET_APP_CONFIG_FAIL
});
